// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** Falkland Islands (Islas Malvinas) */
const FK = /^(?:[56]\d{4})$/;

export default FK;
